import { notification, Modal } from 'ant-design-vue'
import _ from 'lodash'
import { defineComponent } from 'vue'

export default defineComponent({
  methods: {
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmNotificationSuccessMessage
    lmToastSuccessMessage (toastMessage, toastTitle, autoHideDelay = 4.5, props = {}) {
      const {
        notificationTitle = this.$t('good_title'),
        notificationPlacement = 'bottomLeft'
      } = props

      // https://app.clickup.com/t/383x729
      notification.success({
        message: notificationTitle,
        placement: notificationPlacement,
        description: toastMessage,
        duration: autoHideDelay })
    },
    lmNotificationSuccessMessage (toastMessage, toastTitle, autoHideDelay = 4.5, props = {}) {
      props = _.defaultsDeep(props, {
        message: this.$t('good_title'),
        description: '',
        placement: 'bottomLeft',
        duration: 4.5
      })

      // https://app.clickup.com/t/383x729
      notification.success({
        message: props.message,
        placement: props.placement,
        description: props.description,
        duration: props.duration })
    },
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmModalWarningMessage
    lmToastWarningMessage (toastMessage, toastTitle, autoHideDelay = 2, props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'warning',
        resultTitle: this.$t('something_went_wrong'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: toastMessage || props.message
      })
      this.openModal(props)
    },
    lmModalWarningMessage (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'warning',
        resultTitle: this.$t('something_went_wrong'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmModalDangerMessage
    lmToastDangerMessage (toastMessage, toastTitle, autoHideDelay = 2, props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'error',
        resultTitle: this.$t('error_found'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: toastMessage || props.message
      })
      this.openModal(props)
    },
    lmModalDangerMessage (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('review'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: false,
        modalWidth: 600,
        resultStatus: 'error',
        resultTitle: this.$t('error_found'),
        resultSubtitle: this.$t('review_before_trying_again'),
        extraMessageColor: 'red',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    // IMPORTANTE: Metodo existente por compatibilidad hacia atrás
    // En nuevos desarrollos usar lmModalSuccessWithButtons
    lmToastSuccessInternalLink (routerLinkToProperty, toastMessage, toastTitle, props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('view'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: routerLinkToProperty,
        modalWidth: 600,
        resultStatus: 'success',
        resultTitle: this.$t('good_title'),
        resultSubtitle: '',
        extraMessageColor: 'green',
        toastMessage: toastMessage || props.message
      })
      this.openModal(props)
    },
    lmModalSuccessWithButtons (props = {}) {
      props = _.defaultsDeep(props, {
        btnText: this.$t('view'),
        btnType: 'primary',
        btnGhost: true,
        btnLink: props.btnLink,
        modalWidth: 600,
        resultStatus: 'success',
        resultTitle: this.$t('good_title'),
        resultSubtitle: '',
        extraMessageColor: 'green',
        toastMessage: props.message
      })
      this.openModal(props)
    },
    /**
     * Asociado a las mejoras en mensajes de error y exito:
     * https://app.clickup.com/t/383x729
     * Se crea este metodo y se refactorean los toasts y mensajes
     * Los mensajes de error y warning se asumen a partir de ahora que se
     * deben mostrar en un modal, para requerir atencion del usuario.
     *
     * Los mensajes de success por defecto se van a mostrar como notifications
     * de antd https://app.clickup.com/t/383x729.
     *
     * En caso que un mensaje de success sea importante en el producto se va a
     * mostrar como un modal.
     * @param {*} props
     */
    openModal (props = {}) {
      const h = this.$createElement
      props = _.defaultsDeep(props, {
        modalTitle: '',
        modalIconType: '',
        modalCancelButtonProps: { style: { display: 'none' } },
        modalOkButtonProps: { style: { display: 'none' } },
        modalClosable: true,
        modalKeyboard: true,
        modalWidth: 520,
        btnLink: false,
        buttons: []
      })

      // https://1x.antdv.com/components/button/
      let buttons = []
      if (!props.buttons?.length) {
        buttons.push({
          btnType: props.btnType,
          btnGhost: props.btnGhost,
          btnLink: props.btnLink,
          btnText: props.btnText
        })
      } else {
        buttons = props.buttons
      }

      buttons = buttons.map(button => _.defaultsDeep(button, {
        btnClass: 'ml-4 mr-4',
        btnType: 'primary',
        btnGhost: true
      }))

      // https://1x.antdv.com/components/modal/
      Modal.confirm({
        title: props.modalTitle,
        iconType: props.modalIconType,
        cancelButtonProps: props.modalCancelButtonProps,
        okButtonProps: props.modalOkButtonProps,
        closable: props.modalClosable,
        keyboard: props.modalKeyboard,
        width: props.modalWidth,
        // https://1x.antdv.com/components/result/
        content: h(
          'a-result',
          {
            props: {
              status: props.resultStatus,
              title: props.resultTitle,
              'sub-title': props.resultSubtitle,
              extra: [
                h('div',
                  { class: 'desc' },
                  [
                    h('p',
                      { style: { color: props.extraMessageColor } }, [
                        props.toastMessage
                      ])
                  ]
                ),
                buttons.map(button => {
                  return h('a-button', {
                    class: button.btnClass,
                    props: { type: button.btnType, ghost: button.btnGhost },
                    on: { click: () => {
                      if (button.btnLink) {
                        if (button.btnLink === 'goback') {
                          this.$router.go(-1)
                        } else {
                          this.$router.push(button.btnLink)
                        }
                      }
                      Modal.destroyAll()
                    } }
                  }, button.btnText)
                })
              ]
            }
          }
        )
      })
    },
    getOriginNotificationLink (url) {
      const pathArray = url.split('/')
      const protocol = pathArray[0]
      const host = pathArray[2]
      return protocol + '//' + host
    },
    lmToastSuccessPushNotification (link, title, icon, body) {
      const originLink = this.getOriginNotificationLink(link)
      const pathLink = link.replace(originLink, '')
      const appOrigin = window.location.origin
      const areOriginsAppAndLinkEquals = appOrigin === this.getOriginNotificationLink(link)
      const elementToCreate = {
        tag: areOriginsAppAndLinkEquals ? 'router-link' : 'a',
        attr: areOriginsAppAndLinkEquals ? 'to' : 'href',
        link: areOriginsAppAndLinkEquals ? pathLink : link
      }
      const h = this.$createElement
      const vNodesTitle = h(
        elementToCreate.tag,
        {
          class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'],
          attrs: {
            [elementToCreate.attr]: elementToCreate.link
          }
        },
        [
          h('strong', { class: 'mr-2' }, title),
          h(
            'img',
            { class: 'ml-auto',
              attrs: {
                id: 'foo',
                src: icon,
                width: 32,
                heigth: 32
              }
            })
        ]
      )
      const vNodesMsg = h(elementToCreate.tag, { attrs: { [elementToCreate.attr]: elementToCreate.link } }, body)
      this.$bvToast.toast(vNodesMsg, {
        title: [vNodesTitle],
        autoHideDelay: process?.env?.VUE_APP_TOAST_AUTOHIDEDELAY,
        variant: 'info'
      })
    }
  },
  created () {
    const allIdToastToHideWhenMixinsIsCreated = ['lm-toast-success-internal-link']
    allIdToastToHideWhenMixinsIsCreated.forEach(idToast => {
      this.$bvToast.hide(idToast)
    })
  }
})
